export default __webpack_public_path__ + "static/media/RULIcon.040b4cd9.svg";